module.exports = __webpack_public_path__ + "img/img02.ea023759.png";